"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMonthsBetween;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dayjs["default"].extend(_utc["default"]);

function getMonthsBetween(startDate, endDate) {
  return (0, _dayjs["default"])(endDate).utcOffset(0).add(1, 'day').diff(startDate, 'month');
}